<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Laporan Registrasi</li>
                    </ol>
                </div>
                <h4 class="page-title">Laporan Registrasi</h4>
            </div>
        </div>
    </div>

    <div class="card card-loader d-flex" v-if="loading">
        <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
        </div>
    </div>

    <div class="card" v-else>
        <div class="card-body">
        <div class="wrapper-table-default">
            <div class="row mb-3">
                <div class="col-12 col-md-4">
                    <label for="" style="margin-top: 10px;">Periode</label>
                    <date-picker required style="width: 100%" v-model="filter.date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                </div>
                <div class="col-12 col-md-6">
                    <button class="btn btn-primary" @click="loadData" style="margin-top: 33px;">Filter</button>
                    <div class="btn-group ml-2" style="margin-top: 33px;">
                        <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Export Data
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" @click.prevent="exportData('pdf')">PDF</a>
                            <a class="dropdown-item" @click.prevent="exportData('excel')">EXCEL</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>No Urut</th>
                            <th>No Kartu</th>
                            <th class="text-center">Kode Rekam Medik</th>
                            <th class="text-center">Nama Pasien</th>
                            <th class="text-center">Jenis Pasien</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in dataTransaction" :key="item.id">
                            <td>{{item.registration_order}}</td>
                            <td>{{item.customer_code}}</td>
                            <!-- <td>{{checkFieldData(item.fields, 'no-kartu')}}</td> -->
                            <td>{{checkFieldData(item.fields, 'kode-rekam-medik')}}</td>
                            <td>{{item.name ? item.name : '-'}}</td>
                            <td>{{checkFieldData(item.fields, 'jenis-pasien')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
    </div>
      
    <div class="modal fade" id="modalDetail" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <detail-transaction ref="detailTransaction"></detail-transaction>
        </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
import fileDownload from 'js-file-download'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    data() {
        return {
            loading: true,
            loadingExport: false,

            filter: {
                company: null,
                organization: null,
                date: [moment()._d, moment()._d],
                pay_date: [null, null],
                status: null,
            },

            allCompany: [],
            allOrganization: [],
            dataTransaction: [],
            dataTransactionFiltered: [],
        }
    },
    components: {
        DatePicker
    },
    methods: {
        convertPeriod(period) {
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Minggu'
            }else if(period == 'MONTHLY'){
                return 'Bulan'
            }else{
                return 'Tahun'
            }
        },
        checkFieldData(data, field){
            return data.find(item => item.custom.name == field) ? data.find(item => item.custom.name == field).field_value : '-'
        },
        async loadData() {
            this.loading = true;
            try {
                let storedData = {
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                }

                const transaction = await this.$http.get(`${this.API_URL}registration-report`, 
                    {
                        params: storedData,
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` 
                    }
                })
                this.dataTransaction = transaction.data.data

                setTimeout(() => {
                    this.dataTableSearch()
                }, 500);
                
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        async exportData(type) {
            this.loadingExport = true;

            let storedData = {
                start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                export: 1,
                export_type: type
            }

            const response = await this.$http.get(`${this.API_URL}registration-report`, {
                responseType: 'blob',
                params: storedData,
                headers: { 
                    'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                }
            })

            const typeData = type == 'pdf' ? '.pdf' : '.xlsx'
            fileDownload(response.data, 
            `Laporan Registrasi${this.filter.company ? '-' + this.allCompany.find(item => item.id == this.filter.company).name : ''}${this.filter.date[0] ? '-' + this.filter.date[0] : ''}${this.filter.date[1] ? '-' + this.filter.date[1] : ''}${typeData}`);
            
            this.loadingExport = false
        },
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>